@if (!multi) {
    <kendo-combobox
        class="form-control k-combobox border-modern noborder"
        #selectedElement
        [data]="data"
        [textField]="displayProperty"
        [valueField]="'id'"
        [valuePrimitive]="true"
        [popupSettings]="{ width: 'auto' }"
        [filterable]="true"
        [style]="{ width: '350px' }"
        [disabled]="disabled"
        [(ngModel)]="selectedValue"
        (filterChange)="handleFilter($event)"></kendo-combobox>
}

@if (multi) {
    <kendo-multiselect
        class="form-control k-combobox border-modern noborder multiselect"
        #selectedElement
        [data]="data"
        [textField]="displayProperty"
        [valueField]="'id'"
        [valuePrimitive]="true"
        [popupSettings]="{ width: 'auto' }"
        [filterable]="true"
        [style]="{ width: '350px' }"
        [disabled]="disabled"
        [(ngModel)]="selectedValues"
        (filterChange)="handleFilter($event)"></kendo-multiselect>
}
@if (includeExpirationDate && (multi ? selectedValues && selectedValues.length > 0 : selectedValue != null)) {
    <kendo-datepicker
        class="align-self-center ml-3"
        placeholder="{{ 'Expiration Date' | translate }}"
        format="dd.MM.yyyy"
        [(ngModel)]="selectedDate"
        (valueChange)="changeExpirationDateEvent($event)"></kendo-datepicker>
}
<button
    class="btn btn-sm btn-primary ml-3 my-1 align-self-end"
    type="button"
    kendoTooltip
    title="{{ 'Add' | translate }}"
    [disabled]="(multi && (!selectedValues || selectedValues.length === 0)) || (!multi && selectedValue == null)"
    (click)="addElement()">
    <fa-icon [icon]="['fas', 'plus']"></fa-icon>
</button>
